import styled from '@emotion/styled';

export const Billboard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 40px 40px 40px;

  h1 {
    font-size: 36px;
    text-align: center;
  }

  h4 {
    width: 100%;
    font-size: 20px;
    margin: 28px 0 20px 0;
    text-align: center;
  }

  p {
    width: 100%;
    margin-top: 16px;
    text-align: center;
  }

  @media (max-width: 900px) {
    padding: 40px 40px 40px 40px;

    h4 {
      margin: 24px 0 16px 0;
    }

    p {
      margin-top: 0;
    }
  }

  @media (max-width: 780px) {
    padding: 24px 24px 48px 24px;
  }
`;

export const GettingAround = styled.section`
  padding-top: 40px;

  @media (max-width: 780px) {
    padding-top: 24px;
  }
`;

export const GettingAroundContent = styled.section`
  padding: 0 40px;

  @media (max-width: 780px) {
    padding: 0 24px;
  }
`;

export const GettingAroundHeader = styled.div`
  display: inline-block;
  width: 100%;
  height: 2px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: none;
`;

export const Environment = styled.section`
  padding: 40px 0;

  @media (max-width: 780px) {
    padding: 24px 0;
  }
`;

export const EnvironmentContent = styled.div`
  display: grid;
  display: -ms-grid;
  grid-template-rows: auto;
  -ms-grid-rows: auto;
  grid-template-columns: calc(30% - 8px) calc(70% - 8px);
  -ms-grid-columns: calc(30% - 8px) calc(70% - 8px);
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: ${({ theme }) => theme.colors.postnav.background};

  > div:first-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 1;
  }

  > div:last-of-type {
    -ms-grid-row: 1;
    -ms-grid-column: 2;
  }

  div {
    width: 100%;

    h2 {
      color: ${({ theme }) => theme.colors.postnav.title};
    }

    p {
      color: ${({ theme }) => theme.colors.postnav.link};
    }
  }

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 780px) {
    padding: 0 24px;
  }
`;

export const EnvironmentHeader = styled.div`
  height: 30px;
  background: linear-gradient(
    to top right, 
    ${({ theme }) => theme.colors.postnav.background} 50%, 
    ${({ theme }) => theme.colors.background} 51% 100%);
`;

export const EnvironmentFooter = styled.div`
  height: 30px;
  background: linear-gradient(
    to bottom right, 
    ${({ theme }) => theme.colors.postnav.background} 50%, 
    ${({ theme }) => theme.colors.background} 51% 100%);
`;

export const Portal = styled.section`
  padding: 40px 40px 0 40px;

  @media (max-width: 780px) {
    padding: 24px 24px 0 24px;
  }
`;